<template>
  <div id="app">  
    <nav class="navbar navbar-expand-md navbar-dark bg-primary">
        <div class="navbar-collapse collapse w-100 order-1 order-md-0 dual-collapse2">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <button v-if="backsrc" id="back" aria-controls="#intro" @click="goBack()" class="btn text-light order-0 order-md-0 chevron-left chevron-left-white"></button>
                </li>
            </ul>
        </div>
        <div class="mx-auto order-0">
            <div class="navbar-brand mx-auto">
              <img v-if="brand != 'swiss'" class='logo_width logo_height' v-bind:alt="brand + ' logo'" :src="brandlogo" />
              <img v-if="brand == 'swiss'" class='logo_height' v-bind:alt="brand + ' logo'" :src="brandlogo" /><br />{{ this.$t('curbside-pickup') }}
            </div>
            <div class='solid_border'>
              <button @click="changeLang()" class="navbar-toggler" type="button" data-toggle="collapse" data-target=".dual-collapse2">
                  <span class='white'>{{ this.lang == "en" ? "FR" : "EN" }}</span>
              </button>
            </div>
        </div>
        <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <button @click="changeLang()">{{ this.lang == "en" ? "FR" : "EN" }}</button>
                </li>
            </ul>
        </div>
    </nav>   
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      brand: null,
      brandlogo: null,
      navbarheading: this.$t('curbside-pickup'),
      backsrc: null,
      backsrcprev: null,
      lang: 'en'
    }
  },  
  mounted: function () {
    this.setBrand(this.$globalBrand);
  },      
  methods: {
    changeLang() {
      if (this.lang == 'en') {
        this.lang = "fr";
      }
      else {
        this.lang = "en";
      }

      let brand = (''+this.brand).toLowerCase();


      // remap burgers-priest to Harveys
      if (brand.indexOf('bur') >= 0) brand = 'harveys';
      // remap olive garden to ESM
      if (brand.indexOf('oliv') >= 0) brand = 'esm';

      this.$i18n.locale = brand + "-" + this.lang;
    },
    setBrand(brand) {
      // special case for burgers-priest
      if (!brand) return;
      
      this.brand = (''+brand).toLowerCase();
      // remap burgers priest
      if (this.brand === 'bur') this.brand = 'burgers-priest';

      this.brandlogo = '/brand/' + this.brand + '/logo.png';

      if (brand == 'st-hubert') {
        this.lang = 'fr';
      }
      
      // load in brand css
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.href = '/brand/' + brand + '/brand.css'
      file.id = brand + 'Style';
      if (document.querySelector("link[href='"+"/brand/" + brand + "/brand.css"+"']") == null){
        document.head.appendChild(file);                
      }

      var ico = document.querySelector("link[rel*='icon']") || document.createElement('link');
      ico.type = 'image/x-icon';
      ico.rel = 'shortcut icon';
      ico.href = '/brand/' + brand + '/favicon.ico';
      document.getElementsByTagName('head')[0].appendChild(ico);
      
      if (document.querySelector("link[id*='favIconPng']") == null){      
        var icon = document.createElement('link');
        icon.id = 'favIconPng';
        icon.type = 'image/png';
        icon.rel = 'icon';
        icon.href = '/brand/' + brand + '/favicon.png';
        icon.sizes = '32x32';
        document.getElementsByTagName('head')[0].appendChild(icon);
      }
    },
    setHeading(heading) {
      this.navbarheading = heading;
    },
    setBackButton(page) {
      this.backsrcprev = this.backsrc; 
      this.backsrc = page;           
    },
    goBack() {
      this.$router.push({name: this.backsrc}); 
      this.setBackButton(this.backsrcprev);
      if(!this.backsrc){
        this.setHeading(this.$t('curbside-pickup'));
      }
    }
  }   
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 150px;  
}
.navbar{
  min-height: 170px;
}
.navbar-heading{
  width: 100%;
  position: absolute;
  left: 0px;
  color: #fff;
}
#back{
  height: 20px;
  z-index: 1000;
}
.table-responsive{
    -webkit-overflow-scrolling: touch;
}
.fixed-bottom{
  /* workaround to allow iOS devices to render position:fixed properly */
  transform: translate3d(0,0,0);
}
.total button{
  border-radius: 0;
}
.chevron-up{
  background-image: url('/img/chevron-up.svg');
  background-repeat: no-repeat;
  display: inline-block;
  width: 1em;
  height: auto;
  background-size: 1em;
  line-height: 1.1em;  
}
.chevron-up-white{
  background-image: url('/img/chevron-up-white.svg');
}  
.chevron-down{
  background-image: url('/img/chevron-down.svg');
  background-repeat: no-repeat;
  display: inline-block;
  width: 1em;
  height: auto;
  background-size: 1em;
  line-height: 1.1em;  
}
.chevron-down-white{
  background-image: url('/img/chevron-down-white.svg');
}  
.chevron-left{
  background-image: url('/img/chevron-left.svg');
  background-repeat: no-repeat;
  display: inline-block;
  width: 1em;
  height: auto;
  background-size: 1em;
  line-height: 1.1em;  
}
.chevron-left-white{
  background-image: url('/img/chevron-left-white.svg');
}  
.chevron-right{
  background-image: url('/img/chevron-right.svg');
  background-repeat: no-repeat;
  display: inline-block;
  width: 1em;
  height: auto;
  background-size: 1em;
  line-height: 1.1em;  
}
.chevron-right-white{
  background-image: url('/img/chevron-right-white.svg');
}  
.spinner-icon{
  background-image: url('/img/spinner.svg');
  background-repeat: no-repeat;
  width: 94px;
  height: 94px;
  background-size: 94px  94px;
  display: inline-block;
}
.spin {
    -webkit-animation: webkit-spin 2s infinite linear;
    animation: spin 2s infinite linear;
}
.btn-answer {
  background: transparent;
  border: none;  
}
.red-image {
  background: url('/img/thumbs-down.svg');
  width: 85px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: top center;  
  background-size: 85px 100px;    
}

.green-image {
  background: url('/img/thumbs-up.svg');
  width: 85px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 85px 100px;  
}
@-webkit-keyframes webkit-spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
         -webkit-transform: rotate(360deg);
    }  
}
@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}
.payment_option {
  margin: 21px;
  width: 50%;
}

.button {
  padding: 5px;
  border: solid;
  border-width: 1px;
  border-color: #2c3e50;
  background-color: #fff;
}

.text {
  padding-left: 0px;
}

.logo_width {
  width: 120px;
}

.logo_height {
  height: auto;
  width: 100%;
}

@media (max-width: 1000px) {
  .solid_border {
    border: 1px solid white;
  }

  .white {
    color: white;
  }
}
</style>
